import stylesLink from '../link.module.css'
import stylesTheme from '../theme.module.css'
import stylesLinkArrow from './link-arrow.module.css'
import React, { memo, ReactElement } from 'react'
import classNames from 'classnames'
import { getSvg } from '@src/containers/UtmGenerator/helpers'
import { LinkArrowProps } from '../link.types'
import { FormattedHTMLMessage } from 'react-intl'

function LinkArrow({ href, text, theme }: LinkArrowProps): ReactElement {
  const linkClass = classNames(`${stylesLink['link']} ${stylesLinkArrow['link-arrow']}`, {
    [stylesTheme['theme-blue']]: theme === 'blue'
  })

  return (
    <a href={href} className={linkClass}>
      <span className={`${stylesLink['link__text']} ${stylesLinkArrow['link-arrow__text']}`}>
        <FormattedHTMLMessage id={text} />
      </span>
      {getSvg('arrow-dynamic')}
    </a>
  )
}

LinkArrow.defaultProps = {
  theme: 'blue'
}

export default memo(LinkArrow)
